<template>
  <div class="date-range">
    <el-date-picker
      v-model="startDate"
      class="start-date"
      :class="startDate && hideIconWithValue && 'hide-icon'"
      :type="type"
      :clearable="clearable"
      :align="align"
      :format="format"
      :value-format="valueFormat"
      :pickerOptions="startPickerOptions"
    ></el-date-picker>
    <el-date-picker
      v-model="endDate"
      class="end-date"
      :class="endDate && hideIconWithValue && 'hide-icon'"
      :type="type"
      :clearable="clearable"
      :align="align"
      :format="format"
      :value-format="valueFormat"
      :pickerOptions="endPickerOptions"
    ></el-date-picker>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      required: true
    },
    type: {
      type: String
    },
    clearable: {
      type: Boolean,
      default: false
    },
    align: {
      type: String,
      default: 'center'
    },
    format: {
      type: String
    },
    valueFormat: {
      type: String
    },
    hideIconWithValue: {
      type: Boolean,
      default: true
    },
    disabledFutureDate: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {

    }
  },
  computed: {
    startDate: {
      get () {
        return this.value && this.value[0]
      },
      set (val) {
        if (this.endDate && moment(this.startDate).isAfter(this.endDate)) {
          this.endDate = null
          return
        }
        this.$emit('change', [val, this.endDate])
      }
    },
    endDate: {
      get () {
        return this.value && this.value[1]
      },
      set (val) {
        this.$emit('change', [this.startDate, val])
      }
    },
    endPickerOptions () {
      const vm = this
      const nowDate = moment().add(1, 'days').valueOf()
      return {
        disabledDate (time) {
          if (vm.startDate) {
            return time.getTime() < moment(vm.startDate).valueOf() || (vm.disabledFutureDate && time.getTime() > nowDate)
          } else {
            return vm.disabledFutureDate && time.getTime() > nowDate
          }
        }
      }
    },
    startPickerOptions () {
      const vm = this
      const nowDate = moment().add(1, 'days').valueOf()
      return {
        disabledDate (time) {
          if (vm.endDate) {
            return time.getTime() > moment(vm.endDate).valueOf() || (vm.disabledFutureDate && time.getTime() > nowDate)
          } else {
            return vm.disabledFutureDate && time.getTime() > nowDate
          }
        }
      }
    }
  },
  created () {

  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.date-range {
  .start-date {
    &.el-date-editor {
      width: 50%;
    }

    &:hover {
      margin-right: -1px;
      position: relative;
      z-index: 1;

      + .end-date {
        margin-left: 0;
      }
    }

    &.hide-icon {
      ::v-deep {
        .el-input__inner {
          padding: 0 10px;
        }

        .el-input__prefix {
          display: none;
        }
      }
    }

    ::v-deep {
      .el-input__inner {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
    }
  }

  .end-date {
    margin-left: -1px;

    &.el-date-editor {
      width: 50%;
    }

    &.hide-icon {
      ::v-deep {
        .el-input__inner {
          padding: 0 10px;
        }

        .el-input__prefix {
          display: none;
        }
      }
    }

    ::v-deep {
      .el-input__inner {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }
    }
  }
}
</style>
